import { render, staticRenderFns } from "./StandardUserConfirmation.vue?vue&type=template&id=edcb4abc"
import script from "./StandardUserConfirmation.vue?vue&type=script&lang=js"
export * from "./StandardUserConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports